import * as React from 'react';
import { Button, ITagOption, Tags, UIHeading2 } from '@cian/ui-kit';

import { IStateTag } from '../../actions/filterTags';
import * as styles from './SelectedFiltersSection.css';
import { IconActionMore16 } from '@cian/ui-kit-design-tokens/icons';

interface ISelectedFiltersSectionProps {
  tags: IStateTag[];
  onTagDelete: (option: ITagOption) => void;
  onClearAll: () => void;
  getTagIcon?: (tag: IStateTag) => React.ReactNode;
}

export const SelectedFiltersSection: React.FC<ISelectedFiltersSectionProps> = ({
  tags,
  onTagDelete,
  onClearAll,
  getTagIcon,
}) => {
  const options = React.useMemo<ITagOption[]>(
    () =>
      tags.map(tag => ({
        label: tag.label,
        value: JSON.stringify(tag.value) + '/' + tag.label,
        icon: getTagIcon ? getTagIcon(tag) : undefined,
      })),
    [tags, getTagIcon],
  );

  if (!options.length) {
    return null;
  }

  return (
    <div className={styles['container']}>
      <UIHeading2>Уже выбрали</UIHeading2>
      <Tags
        options={options}
        onClose={onTagDelete}
        displayModeOptions={{
          hideText: undefined,
          isFoldable: true,
          isFolded: true,
          maxLines: 1,
          showMoreText: undefined,
          expandCollapseAdornment: isExpanded => (
            <Button
              theme="fill_white_primary"
              size="XS"
              beforeIcon={isExpanded ? undefined : <IconActionMore16 color="current_color" />}
            >
              {isExpanded ? 'Свернуть' : ''}
            </Button>
          ),
        }}
        rightAdornment={
          tags.length > 2 ? (
            <Button size="XS" theme="fill_white_primary" type="button" onClick={onClearAll}>
              Очистить
            </Button>
          ) : undefined
        }
      />
    </div>
  );
};
